import React from 'react'
import { Flex } from '@theme-ui/components'
import Menu from '../components/Menu/v1/Menu'

export default function MenuV1({ businessData, configData, options, gonationID, variantName }) {
  // const { containerStyles } = options
  const variant = variantName ? variantName : 'menuV1'
  const styles = options?.containerStyles ? JSON.parse(options?.containerStyles) : {}
  return (
    <Flex variant={`${variant}.container`} sx={styles}>
      <Menu
        poweredListID={`powered-list-${options?.powerListNumber}`}
        gonationID={gonationID}
        businessData={businessData}
        configData={configData}
        variantName={variant}
        options={options}
      />
    </Flex>
  )
}
